import compareVersion from 'hooks/versionChecker/helpers/compareVersion'
import moment from 'moment'
import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import ConfirmationDialog from '../../components/ReusableComponents/ConfirmationDialog'
import styles from './useVersionChecker.module.scss'
import versionCheckerSlice, { fetchRemoteVersion } from './versionCheckerSlice'

const { actions } = versionCheckerSlice

const CHECK_VERSION_AFTER_MINUTES = 5

function VersionChecker() {
  const localVersion = useSelector(s => s.versionInfo.localVersion)
  const remoteVersion = useSelector(s => s.versionInfo.remoteVersion)
  const lastChecked = useSelector(s => s.versionInfo.lastChecked)
  const dispatch = useDispatch()

  const [updateNotes, setUpdateNotes] = useState('')

  const [showUpdateDialog, setShowUpdateDialog] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (!localVersion) {
      dispatch(actions.updateLocalVersion(process.env.REACT_APP_VERSION))
    }
  }, [localVersion, dispatch])

  useEffect(() => {
    if (!remoteVersion) {
      dispatch(fetchRemoteVersion())
    }
  }, [dispatch, remoteVersion])

  useEffect(() => {
    if (['major', 'feat'].includes(compareVersion(localVersion, remoteVersion))) {
      setShowUpdateDialog(true)
    } else {
      setShowUpdateDialog(false)
    }
  }, [localVersion, dispatch, remoteVersion, lastChecked])

  useEffect(() => {
    if (lastChecked) {
      const diff = moment().diff(moment(lastChecked), 'minutes')
      if (diff > CHECK_VERSION_AFTER_MINUTES) {
        dispatch(fetchRemoteVersion())
      }
    }
  }, [dispatch, lastChecked, location])

  function reload() {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.update()
    })
    window.location.reload(true)
  }

  // try to fetch update notes

  useEffect(() => {
    if (remoteVersion && updateNotes?.version !== remoteVersion) {
      const featVersion = remoteVersion?.replace(/(\d+\.\d+)\.\d+/, '$1.0')

      fetch(`${document.location.origin}/change-logs/${featVersion}/index.md`)
        .then(remoteMd => remoteMd.text())
        .then(md =>
          md.replace('./', `${document.location.origin}/change-logs/${featVersion}/`)
        )
        .then(remoteMd =>
          remoteMd.includes('<html')
            ? null
            : setUpdateNotes({ version: remoteVersion, markdown: remoteMd })
        )
        .catch(err => console.warn('could not fetch update notes', err))
    }
  }, [remoteVersion, updateNotes?.version])

  if (showUpdateDialog) {
    return (
      <ConfirmationDialog
        positiveMessage="Update now"
        hasHeader={false}
        negativeMessage="Update later"
        onConfirm={reload}
        onClose={() => setShowUpdateDialog(false)}
      >
        <div className={styles.changeLogWrapper}>
          <div className={styles.changeLog}>
            {updateNotes ? (
              <ReactMarkdown>{updateNotes.markdown}</ReactMarkdown>
            ) : (
              <>
                <h1>Version {remoteVersion?.replace(/(\d+\.\d+)\.\d+/, '$1.0')}</h1>
                <p>New version of Directful Dashboard is available.</p>
                <p>Click update button to get new features.</p>
              </>
            )}
          </div>
        </div>
      </ConfirmationDialog>
    )
  }

  return null
}

export default VersionChecker
